import 'jquery-inview';



let breakPoint = 768;
let scrollPosition = $(window).scrollTop();

$(function () {

  $(window).on('load', function () {
    setTimeout(function () {
      infographicView($(window).scrollTop());
    }, 0);
  });

  $(window).on('scroll resize', function () {
    infographicView($(this).scrollTop());
    scrollPosition = $(this).scrollTop();
  });

  //  $('.lists-infographic-slides').on('touchstart', TouchStart);
  //  function TouchStart(event) {
  //    infographicView($(window).scrollTop());
  //  }

});

function infographicView(scrollTop) {
  $('.lists-infographic .sec-list.inviewCount').not('.anime-start').each(function (i) {
    let $this = $(this);
    $this.find('.countzero, .count .number, .countup').html('');
    let startY = 150;
    if ($(window).width() <= breakPoint) {
      startY = 50;
    }
    if ((scrollTop > $this.offset().top - $(window).height() + startY && scrollTop >= scrollPosition) || (scrollTop > $this.offset().top + startY / 3 && scrollTop < scrollPosition && scrollTop < $this.offset().top + $this.height() - 150)) {

      $this.addClass('anime-start');
      setTimeout(function () {
        $this.addClass('anime--start');
        $this.find('.counter').addClass('anime--fadein');
      }, 300 * (i + 1));
      setTimeout(function () {
        $this.find('.tx-number').fadeIn();
        count1($this);
      }, 500 * (i + 1));
    }
  });

}

function count1(targetID) {
  /*
  if ($(targetID).hasClass('list-infographic1') || $(targetID).hasClass('list-infographic3') || $(targetID).hasClass('list-infographic6')) {
    $(targetID).find('.icons .img-icon').each(function (i) {
      $(this).delay(60 * i).queue(function () {
        $(this).addClass('icon-fadein');
      });
    });
  }
  if ($(targetID).hasClass('list-infographic4')) {
    $(targetID).find('.chart--horiz li').each(function (i) {
      $(this).delay(100 * i).queue(function () {
        $(this).addClass('bar-fadein');
      });
    });
  }
  */

  $(targetID).find('.countzero').each(function (i) {
    let $this = $(this);
    let tgt = $(this).data('num');
    let num = i;
    let speed = 20;
    let countset = setInterval(function () {
      $this.html(num);
      if (num == 9) {
        num = 0;
      }
      num++;
    }, speed);
    setTimeout(function () {
      $this.html(tgt);
      clearInterval(countset);
    }, 800);
  });
}



$('.lists-infographic .sec-list').each(function () {
  $(this).on('inview', function () {
    $(this).addClass('inviewCount');
  });
});

//棒グラフ
$('.inviewBar').on('inview', function () {
  var $this = $(this);
  $this.addClass('bargraph-start');
  setTimeout(function () {
    $this.next().addClass('is-view');
  }, 800);
});

//円グラフ
$('.inviewCircle').on('inview', function () {
  var $this = $(this);
  $this.find('.pie').addClass('circle-start');
  setTimeout(function () {
    $this.find('figcaption').addClass('is-view');
  }, 800);
});

//アイコン
$('.inviewIcon').on('inview', function () {
  var $this = $(this);
  $this.addClass('is-view');
});


// specialcontents-secのアニメーション用
$(function () {
  $('.specialcontents-sec .number').one('inview', function () {  // .boxから.numberに変更
    let $this = $(this);

    // アイコンのフェードイン
    $this.siblings('.icon').addClass('is-view');  // 親要素に対して.iconを探す

    // 数字のアニメーション
    $this.find('.countzero').each(function () {
      let $counter = $(this);
      let tgt = $counter.data('num');
      let num = 0;
      let speed = 20;

      let countset = setInterval(function () {
        $counter.html(num);
        if (num == 9) {
          num = 0;
        }
        num++;
      }, speed);

      setTimeout(function () {
        $counter.html(tgt);
        clearInterval(countset);
      }, 800);
    });
  });
});
